/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AuditLogListResponse,
  AuditLogResponse,
  ComponentLogsResponse,
  CreateDeploymentTarget,
  CreateInstance,
  CreateInstanceDefinition,
  CreateOperator,
  CreateOrganization,
  CreateSourceRepository,
  DeleteDeploymentTargetBody,
  DeleteInstanceBody,
  DeleteInstanceDefinitionBody,
  DeleteOperatorBody,
  DeleteOrganizationBody,
  DeleteSourceRepositoryBody,
  DeploymentTargetListResponse,
  DeploymentTargetResponse,
  InitialOperatorSetup,
  InitialOperatorSetupResponse,
  InstanceComponentListResponse,
  InstanceComponentResponse,
  InstanceDefinitionListResponse,
  InstanceDefinitionResponse,
  InstanceListResponse,
  InstanceResponse,
  Login,
  LoginResponse,
  OperatorListResponse,
  OperatorResponse,
  OrganizationListResponse,
  OrganizationResponse,
  ProfileResponse,
  RefreshToken,
  RefreshTokenResponse,
  SecretListResponse,
  SecretValueResponse,
  SetupStatusResponse,
  SourceRepositoryListResponse,
  SourceRepositoryResponse,
  TestConnectionResponse,
  UpdateComponentDomain,
  UpdateDeploymentTargetBody,
  UpdateInstanceBody,
  UpdateInstanceDefinitionBody,
  UpdateOperatorBody,
  UpdateOrganizationBody,
  UpdateProfile,
  UpdateSourceRepositoryBody,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Api<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Operators
   * @name OperatorsCreate
   * @summary Create a new operator
   * @request POST:/api/operators
   * @secure
   */
  operatorsCreate = (data: CreateOperator, params: RequestParams = {}) =>
    this.request<OperatorResponse, void>({
      path: `/api/operators`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Operators
   * @name OperatorsList
   * @summary List operators
   * @request GET:/api/operators
   * @secure
   */
  operatorsList = (params: RequestParams = {}) =>
    this.request<OperatorListResponse, void>({
      path: `/api/operators`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Operators
   * @name OperatorsDetail
   * @summary Get operator by ID
   * @request GET:/api/operators/{id}
   * @secure
   */
  operatorsDetail = (id: string, params: RequestParams = {}) =>
    this.request<OperatorResponse, void>({
      path: `/api/operators/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Operators
   * @name OperatorsPartialUpdate
   * @summary Update operator
   * @request PATCH:/api/operators/{id}
   * @secure
   */
  operatorsPartialUpdate = (
    id: string,
    data: UpdateOperatorBody,
    params: RequestParams = {},
  ) =>
    this.request<OperatorResponse, void>({
      path: `/api/operators/${id}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Operators
   * @name OperatorsDelete
   * @summary Delete operator
   * @request DELETE:/api/operators/{id}
   * @secure
   */
  operatorsDelete = (
    id: string,
    data: DeleteOperatorBody,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/operators/${id}`,
      method: "DELETE",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Operators
   * @name OperatorsAuditList
   * @summary Get operator audit history
   * @request GET:/api/operators/{id}/audit
   * @secure
   */
  operatorsAuditList = (id: string, params: RequestParams = {}) =>
    this.request<AuditLogResponse[], void>({
      path: `/api/operators/${id}/audit`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Operators
   * @name OperatorsMeList
   * @summary Get current operator profile
   * @request GET:/api/operators/me
   * @secure
   */
  operatorsMeList = (params: RequestParams = {}) =>
    this.request<ProfileResponse, void>({
      path: `/api/operators/me`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Operators
   * @name OperatorsMePartialUpdate
   * @summary Update current operator profile
   * @request PATCH:/api/operators/me
   * @secure
   */
  operatorsMePartialUpdate = (
    data: UpdateProfile,
    params: RequestParams = {},
  ) =>
    this.request<ProfileResponse, void>({
      path: `/api/operators/me`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Authenticate an operator and receive JWT access and refresh tokens.
   *
   * @tags Auth
   * @name AuthLoginCreate
   * @summary Login with credentials
   * @request POST:/api/auth/login
   */
  authLoginCreate = (data: Login, params: RequestParams = {}) =>
    this.request<LoginResponse, void>({
      path: `/api/auth/login`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Use a valid refresh token to obtain a new access and refresh token pair.
   *
   * @tags Auth
   * @name AuthRefreshCreate
   * @summary Refresh access token
   * @request POST:/api/auth/refresh
   */
  authRefreshCreate = (data: RefreshToken, params: RequestParams = {}) =>
    this.request<RefreshTokenResponse, void>({
      path: `/api/auth/refresh`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Returns whether the system has been configured (has at least one operator).
   *
   * @tags Setup
   * @name SetupStatusList
   * @summary Check setup status
   * @request GET:/api/setup/status
   */
  setupStatusList = (params: RequestParams = {}) =>
    this.request<SetupStatusResponse, any>({
      path: `/api/setup/status`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Creates the first operator with super_admin role. Only available when no operators exist.
   *
   * @tags Setup
   * @name SetupInitialOperatorCreate
   * @summary Create initial operator
   * @request POST:/api/setup/initial-operator
   */
  setupInitialOperatorCreate = (
    data: InitialOperatorSetup,
    params: RequestParams = {},
  ) =>
    this.request<InitialOperatorSetupResponse, void>({
      path: `/api/setup/initial-operator`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Returns a paginated list of audit log entries with optional filtering, sorting, and text search.
   *
   * @tags Audit
   * @name AuditLogsList
   * @summary List audit logs
   * @request GET:/api/audit-logs
   * @secure
   */
  auditLogsList = (params: RequestParams = {}) =>
    this.request<AuditLogListResponse, void>({
      path: `/api/audit-logs`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Returns all audit log entries for a specific entity.
   *
   * @tags Audit
   * @name AuditLogsDetail
   * @summary Get entity audit history
   * @request GET:/api/audit-logs/{entityType}/{entityId}
   * @secure
   */
  auditLogsDetail = (
    entityType: string,
    entityId: string,
    params: RequestParams = {},
  ) =>
    this.request<AuditLogResponse[], void>({
      path: `/api/audit-logs/${entityType}/${entityId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Organizations
   * @name OrganizationsCreate
   * @summary Create a new organization
   * @request POST:/api/organizations
   * @secure
   */
  organizationsCreate = (
    data: CreateOrganization,
    params: RequestParams = {},
  ) =>
    this.request<OrganizationResponse, void>({
      path: `/api/organizations`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Organizations
   * @name OrganizationsList
   * @summary List organizations
   * @request GET:/api/organizations
   * @secure
   */
  organizationsList = (params: RequestParams = {}) =>
    this.request<OrganizationListResponse, void>({
      path: `/api/organizations`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Organizations
   * @name OrganizationsDetail
   * @summary Get organization by ID
   * @request GET:/api/organizations/{id}
   * @secure
   */
  organizationsDetail = (id: string, params: RequestParams = {}) =>
    this.request<OrganizationResponse, void>({
      path: `/api/organizations/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Organizations
   * @name OrganizationsPartialUpdate
   * @summary Update organization
   * @request PATCH:/api/organizations/{id}
   * @secure
   */
  organizationsPartialUpdate = (
    id: string,
    data: UpdateOrganizationBody,
    params: RequestParams = {},
  ) =>
    this.request<OrganizationResponse, void>({
      path: `/api/organizations/${id}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Organizations
   * @name OrganizationsDelete
   * @summary Delete organization
   * @request DELETE:/api/organizations/{id}
   * @secure
   */
  organizationsDelete = (
    id: string,
    data: DeleteOrganizationBody,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/organizations/${id}`,
      method: "DELETE",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Organizations
   * @name OrganizationsAuditList
   * @summary Get organization audit history
   * @request GET:/api/organizations/{id}/audit
   * @secure
   */
  organizationsAuditList = (id: string, params: RequestParams = {}) =>
    this.request<AuditLogListResponse, void>({
      path: `/api/organizations/${id}/audit`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Lists all secrets in the store. Secret values are never returned. Also returns orphan refs — secrets that exist in the store but are not referenced by any entity.
   *
   * @tags Secrets
   * @name SecretsList
   * @summary List all secrets
   * @request GET:/api/secrets
   * @secure
   */
  secretsList = (params: RequestParams = {}) =>
    this.request<SecretListResponse, any>({
      path: `/api/secrets`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Returns the decrypted plaintext value of a secret. Restricted to super_admin only. Use only in emergency situations.
   *
   * @tags Secrets
   * @name SecretsValueList
   * @summary Reveal secret value
   * @request GET:/api/secrets/{id}/value
   * @secure
   */
  secretsValueList = (id: string, params: RequestParams = {}) =>
    this.request<SecretValueResponse, void>({
      path: `/api/secrets/${id}/value`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Deletes a secret by its ID. Returns 409 if the secret is still referenced.
   *
   * @tags Secrets
   * @name SecretsDelete
   * @summary Delete a secret
   * @request DELETE:/api/secrets/{id}
   * @secure
   */
  secretsDelete = (id: string, params: RequestParams = {}) =>
    this.request<void, void>({
      path: `/api/secrets/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Deployment Targets
   * @name DeploymentTargetsCreate
   * @summary Create a new deployment target
   * @request POST:/api/deployment-targets
   * @secure
   */
  deploymentTargetsCreate = (
    data: CreateDeploymentTarget,
    params: RequestParams = {},
  ) =>
    this.request<DeploymentTargetResponse, void>({
      path: `/api/deployment-targets`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Deployment Targets
   * @name DeploymentTargetsList
   * @summary List deployment targets
   * @request GET:/api/deployment-targets
   * @secure
   */
  deploymentTargetsList = (params: RequestParams = {}) =>
    this.request<DeploymentTargetListResponse, void>({
      path: `/api/deployment-targets`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Deployment Targets
   * @name DeploymentTargetsDetail
   * @summary Get deployment target by ID
   * @request GET:/api/deployment-targets/{id}
   * @secure
   */
  deploymentTargetsDetail = (id: string, params: RequestParams = {}) =>
    this.request<DeploymentTargetResponse, void>({
      path: `/api/deployment-targets/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Deployment Targets
   * @name DeploymentTargetsPartialUpdate
   * @summary Update deployment target
   * @request PATCH:/api/deployment-targets/{id}
   * @secure
   */
  deploymentTargetsPartialUpdate = (
    id: string,
    data: UpdateDeploymentTargetBody,
    params: RequestParams = {},
  ) =>
    this.request<DeploymentTargetResponse, void>({
      path: `/api/deployment-targets/${id}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Deployment Targets
   * @name DeploymentTargetsDelete
   * @summary Delete deployment target
   * @request DELETE:/api/deployment-targets/{id}
   * @secure
   */
  deploymentTargetsDelete = (
    id: string,
    data: DeleteDeploymentTargetBody,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/deployment-targets/${id}`,
      method: "DELETE",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Deployment Targets
   * @name DeploymentTargetsAuditList
   * @summary Get deployment target audit history
   * @request GET:/api/deployment-targets/{id}/audit
   * @secure
   */
  deploymentTargetsAuditList = (id: string, params: RequestParams = {}) =>
    this.request<AuditLogListResponse, void>({
      path: `/api/deployment-targets/${id}/audit`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Deployment Targets
   * @name DeploymentTargetsTestConnectionCreate
   * @summary Test connection to deployment target
   * @request POST:/api/deployment-targets/{id}/test-connection
   * @secure
   */
  deploymentTargetsTestConnectionCreate = (
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<TestConnectionResponse, void>({
      path: `/api/deployment-targets/${id}/test-connection`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Instances
   * @name InstancesCreate
   * @summary Create a new Bonsai instance
   * @request POST:/api/instances
   * @secure
   */
  instancesCreate = (data: CreateInstance, params: RequestParams = {}) =>
    this.request<InstanceResponse, void>({
      path: `/api/instances`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Instances
   * @name InstancesList
   * @summary List instances
   * @request GET:/api/instances
   * @secure
   */
  instancesList = (params: RequestParams = {}) =>
    this.request<InstanceListResponse, void>({
      path: `/api/instances`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Instances
   * @name InstancesDetail
   * @summary Get instance by ID
   * @request GET:/api/instances/{id}
   * @secure
   */
  instancesDetail = (id: string, params: RequestParams = {}) =>
    this.request<InstanceResponse, void>({
      path: `/api/instances/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Instances
   * @name InstancesPartialUpdate
   * @summary Update instance
   * @request PATCH:/api/instances/{id}
   * @secure
   */
  instancesPartialUpdate = (
    id: string,
    data: UpdateInstanceBody,
    params: RequestParams = {},
  ) =>
    this.request<InstanceResponse, void>({
      path: `/api/instances/${id}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Instances
   * @name InstancesDelete
   * @summary Delete instance
   * @request DELETE:/api/instances/{id}
   * @secure
   */
  instancesDelete = (
    id: string,
    data: DeleteInstanceBody,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/instances/${id}`,
      method: "DELETE",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Instances
   * @name InstancesAuditList
   * @summary Get instance audit history
   * @request GET:/api/instances/{id}/audit
   * @secure
   */
  instancesAuditList = (id: string, params: RequestParams = {}) =>
    this.request<AuditLogListResponse, void>({
      path: `/api/instances/${id}/audit`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Instances
   * @name InstancesComponentsList
   * @summary Get instance components
   * @request GET:/api/instances/{id}/components
   * @secure
   */
  instancesComponentsList = (id: string, params: RequestParams = {}) =>
    this.request<InstanceComponentResponse[], void>({
      path: `/api/instances/${id}/components`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Instances
   * @name InstancesDeployCreate
   * @summary Deploy instance
   * @request POST:/api/instances/{id}/deploy
   * @secure
   */
  instancesDeployCreate = (id: string, params: RequestParams = {}) =>
    this.request<InstanceResponse, void>({
      path: `/api/instances/${id}/deploy`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Instances
   * @name InstancesStopCreate
   * @summary Stop instance
   * @request POST:/api/instances/{id}/stop
   * @secure
   */
  instancesStopCreate = (id: string, params: RequestParams = {}) =>
    this.request<InstanceResponse, void>({
      path: `/api/instances/${id}/stop`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Instances
   * @name InstancesStartCreate
   * @summary Start instance
   * @request POST:/api/instances/{id}/start
   * @secure
   */
  instancesStartCreate = (id: string, params: RequestParams = {}) =>
    this.request<InstanceResponse, void>({
      path: `/api/instances/${id}/start`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Instances
   * @name InstancesRedeployCreate
   * @summary Redeploy instance (in-place rebuild)
   * @request POST:/api/instances/{id}/redeploy
   * @secure
   */
  instancesRedeployCreate = (id: string, params: RequestParams = {}) =>
    this.request<InstanceResponse, void>({
      path: `/api/instances/${id}/redeploy`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Instances
   * @name InstancesSyncConfigCreate
   * @summary Sync instance config from its definition
   * @request POST:/api/instances/{id}/sync-config
   * @secure
   */
  instancesSyncConfigCreate = (id: string, params: RequestParams = {}) =>
    this.request<InstanceResponse, void>({
      path: `/api/instances/${id}/sync-config`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Instances
   * @name InstancesTeardownCreate
   * @summary Teardown instance
   * @request POST:/api/instances/{id}/teardown
   * @secure
   */
  instancesTeardownCreate = (id: string, params: RequestParams = {}) =>
    this.request<InstanceResponse, void>({
      path: `/api/instances/${id}/teardown`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Instance Components
   * @name InstanceComponentsList
   * @summary List all instance components
   * @request GET:/api/instance-components
   * @secure
   */
  instanceComponentsList = (params: RequestParams = {}) =>
    this.request<InstanceComponentListResponse, void>({
      path: `/api/instance-components`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Instance Components
   * @name InstanceComponentsDetail
   * @summary Get instance component by ID
   * @request GET:/api/instance-components/{id}
   * @secure
   */
  instanceComponentsDetail = (id: string, params: RequestParams = {}) =>
    this.request<InstanceComponentResponse, void>({
      path: `/api/instance-components/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Instance Components
   * @name InstanceComponentsHealthList
   * @summary Get component health status
   * @request GET:/api/instance-components/{id}/health
   * @secure
   */
  instanceComponentsHealthList = (id: string, params: RequestParams = {}) =>
    this.request<InstanceComponentResponse, void>({
      path: `/api/instance-components/${id}/health`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Instance Components
   * @name InstancesComponentsStopCreate
   * @summary Stop a component
   * @request POST:/api/instances/{instanceId}/components/{id}/stop
   * @secure
   */
  instancesComponentsStopCreate = (
    instanceId: string,
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<InstanceComponentResponse, void>({
      path: `/api/instances/${instanceId}/components/${id}/stop`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Instance Components
   * @name InstancesComponentsStartCreate
   * @summary Start a component
   * @request POST:/api/instances/{instanceId}/components/{id}/start
   * @secure
   */
  instancesComponentsStartCreate = (
    instanceId: string,
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<InstanceComponentResponse, void>({
      path: `/api/instances/${instanceId}/components/${id}/start`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Instance Components
   * @name InstancesComponentsRedeployCreate
   * @summary Redeploy a component (in-place rebuild)
   * @request POST:/api/instances/{instanceId}/components/{id}/redeploy
   * @secure
   */
  instancesComponentsRedeployCreate = (
    instanceId: string,
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<InstanceComponentResponse, void>({
      path: `/api/instances/${instanceId}/components/${id}/redeploy`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Instance Components
   * @name InstancesComponentsDomainPartialUpdate
   * @summary Update component custom domain configuration
   * @request PATCH:/api/instances/{instanceId}/components/{id}/domain
   * @secure
   */
  instancesComponentsDomainPartialUpdate = (
    instanceId: string,
    id: string,
    data: UpdateComponentDomain,
    params: RequestParams = {},
  ) =>
    this.request<InstanceComponentResponse, void>({
      path: `/api/instances/${instanceId}/components/${id}/domain`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Instance Components
   * @name InstancesComponentsLogsList
   * @summary Get component container logs
   * @request GET:/api/instances/{instanceId}/components/{id}/logs
   * @secure
   */
  instancesComponentsLogsList = (
    instanceId: string,
    id: string,
    query?: {
      /**
       * Number of log lines to return from the end
       * @min 1
       * @max 10000
       * @default 100
       */
      tail?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<ComponentLogsResponse, void>({
      path: `/api/instances/${instanceId}/components/${id}/logs`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Source Repositories
   * @name SourceRepositoriesCreate
   * @summary Create a new source repository
   * @request POST:/api/source-repositories
   * @secure
   */
  sourceRepositoriesCreate = (
    data: CreateSourceRepository,
    params: RequestParams = {},
  ) =>
    this.request<SourceRepositoryResponse, void>({
      path: `/api/source-repositories`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Source Repositories
   * @name SourceRepositoriesList
   * @summary List source repositories
   * @request GET:/api/source-repositories
   * @secure
   */
  sourceRepositoriesList = (params: RequestParams = {}) =>
    this.request<SourceRepositoryListResponse, void>({
      path: `/api/source-repositories`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Source Repositories
   * @name SourceRepositoriesDetail
   * @summary Get source repository by ID
   * @request GET:/api/source-repositories/{id}
   * @secure
   */
  sourceRepositoriesDetail = (id: string, params: RequestParams = {}) =>
    this.request<SourceRepositoryResponse, void>({
      path: `/api/source-repositories/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Source Repositories
   * @name SourceRepositoriesPartialUpdate
   * @summary Update source repository
   * @request PATCH:/api/source-repositories/{id}
   * @secure
   */
  sourceRepositoriesPartialUpdate = (
    id: string,
    data: UpdateSourceRepositoryBody,
    params: RequestParams = {},
  ) =>
    this.request<SourceRepositoryResponse, void>({
      path: `/api/source-repositories/${id}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Source Repositories
   * @name SourceRepositoriesDelete
   * @summary Delete source repository
   * @request DELETE:/api/source-repositories/{id}
   * @secure
   */
  sourceRepositoriesDelete = (
    id: string,
    data: DeleteSourceRepositoryBody,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/source-repositories/${id}`,
      method: "DELETE",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Source Repositories
   * @name SourceRepositoriesAuditList
   * @summary Get source repository audit history
   * @request GET:/api/source-repositories/{id}/audit
   * @secure
   */
  sourceRepositoriesAuditList = (id: string, params: RequestParams = {}) =>
    this.request<AuditLogListResponse, void>({
      path: `/api/source-repositories/${id}/audit`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Instance Definitions
   * @name InstanceDefinitionsCreate
   * @summary Create a new instance definition
   * @request POST:/api/instance-definitions
   * @secure
   */
  instanceDefinitionsCreate = (
    data: CreateInstanceDefinition,
    params: RequestParams = {},
  ) =>
    this.request<InstanceDefinitionResponse, void>({
      path: `/api/instance-definitions`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Instance Definitions
   * @name InstanceDefinitionsList
   * @summary List instance definitions
   * @request GET:/api/instance-definitions
   * @secure
   */
  instanceDefinitionsList = (params: RequestParams = {}) =>
    this.request<InstanceDefinitionListResponse, void>({
      path: `/api/instance-definitions`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Instance Definitions
   * @name InstanceDefinitionsDetail
   * @summary Get instance definition by ID
   * @request GET:/api/instance-definitions/{id}
   * @secure
   */
  instanceDefinitionsDetail = (id: string, params: RequestParams = {}) =>
    this.request<InstanceDefinitionResponse, void>({
      path: `/api/instance-definitions/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Instance Definitions
   * @name InstanceDefinitionsPartialUpdate
   * @summary Update instance definition
   * @request PATCH:/api/instance-definitions/{id}
   * @secure
   */
  instanceDefinitionsPartialUpdate = (
    id: string,
    data: UpdateInstanceDefinitionBody,
    params: RequestParams = {},
  ) =>
    this.request<InstanceDefinitionResponse, void>({
      path: `/api/instance-definitions/${id}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Instance Definitions
   * @name InstanceDefinitionsDelete
   * @summary Delete instance definition
   * @request DELETE:/api/instance-definitions/{id}
   * @secure
   */
  instanceDefinitionsDelete = (
    id: string,
    data: DeleteInstanceDefinitionBody,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/instance-definitions/${id}`,
      method: "DELETE",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Instance Definitions
   * @name InstanceDefinitionsAuditList
   * @summary Get instance definition audit history
   * @request GET:/api/instance-definitions/{id}/audit
   * @secure
   */
  instanceDefinitionsAuditList = (id: string, params: RequestParams = {}) =>
    this.request<AuditLogListResponse, void>({
      path: `/api/instance-definitions/${id}/audit`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
}
